import React, { Component } from 'react';
import ContentHeader from './ContentHeader';

class Dashboard extends Component {
  render() {
    return (
      <div>
        <ContentHeader title="Dashboard" />
        <h2> Checklist for week goes here </h2>
      </div>
    )
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Dashboard.js